import type { DailyCloseHead, DailyCloseItem } from '@/services/inventory/dailyClose/types'
import { DailyCloseSplitTables, type DailyCloseTablesProps } from '../../dailyCloseShared/DailyCloseSplitTables'
import { HEAD_COLUMNS, ITEM_COLUMNS } from './columnDefinitions'

export function DailyCloseTables(props: Readonly<DailyCloseTablesProps<DailyCloseHead, DailyCloseItem>>) {
  return <DailyCloseSplitTables<DailyCloseHead, DailyCloseItem> {...props} headColumns={HEAD_COLUMNS} itemColumns={ITEM_COLUMNS} />
}
